import React, { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Col, Container, Row, Form, Input, Label,
  Card, CardBody, Button, FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import { classApi } from "apis/ClassListApi"
import Swal from "sweetalert2"
import { CircularApi } from "apis/CircularAPI"
import { SessionContext } from "context/sessionContext"
import Loading from "components/Loading"
import { classGroupApi } from "apis/ClassGroupApi"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"

const CreateCircular = props => {
  document.title = "Create Circular"
  const [user] = useState(JSON.parse(localStorage.getItem("User")))
  const [classList, setClassList] = useState([])
  const [loading, setloading] = useState(false)
  const [AllClassGroup, setAllClassGroup] = useState([])
  const { Session } = useContext(SessionContext)
  let session = Session || sessionStorage.getItem("SessionId")

  useEffect(() => {
    classApi.getAllClass()
      .then(res => setClassList(res.data.section_list))
      .catch(err => console.log(err))

    classGroupApi.getClassGroup().then(res => {
      const groups = res.data?.grupofclass?.map(g => ({
        value: g.id,
        label: g.group_name,
        st_class: g.st_class,
      }))
      setAllClassGroup(groups || [])
    })
  }, [])

  const classListOption = classList?.map(cl => ({
    value: cl.UID,
    label: `${cl.st_class} ${cl.st_sec}`,
  }))

  const SendListOption = [
    { value: 1, label: "Teacher" },
    { value: 2, label: "Student" },
    { value: 3, label: "Parent" },
  ]

  const MAX_FILE_SIZE = 5 * 1024 * 1024

  const validation = useFormik({
    enableReinitialize: false,
    initialValues: {
      title: "",
      description: "",
      st_class: [],
      send_by: [],
      notice_file: "",
      circular_end_date: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Title"),
      st_class: Yup.array().min(1, "This is required"),
      send_by: Yup.array().min(1, "This is required"),
      notice_file: Yup.mixed()
        .test("fileSize", "File size exceeds the limit of 5 MB.",
          value => !value || value.size <= MAX_FILE_SIZE)
        .notRequired(),
    }),
    onSubmit: values => {
      setloading(true)
      const data = new FormData()
      data.append("notice_file", values.notice_file)
      data.append("title", values.title)
      data.append("description", values.description)

      if (user === "Admin") {
        data.append("groupofclass_ids", JSON.stringify(values.st_class || []))
        const classes = []
        ;(values.st_class || []).forEach(groupId => {
          const group = AllClassGroup.find(g => g.value === groupId)
          if (group?.st_class) {
            try {
              JSON.parse(group.st_class).forEach(c => classes.push(c))
            } catch (e) {}
          }
        })
        data.append("st_class", JSON.stringify(classes))
      } else {
        data.append("st_class", JSON.stringify(values.st_class))
      }

      data.append("send_by", JSON.stringify(values.send_by))
      const currentSession = Session || sessionStorage.getItem("SessionId") || session
      data.append("session_id", currentSession)
      if (values.circular_end_date) {
        data.append("circular_end_date", values.circular_end_date)
      }

      CircularApi.createCircular(data)
        .then(res => {
          setloading(false)
          if (res.data.status === 200) {
            Swal.fire({ text: res.data.msg, icon: "success" }).then(result => {
              if (result.isConfirmed) window.location.href = "/circular"
            })
          }
          if (res.data.status === 403) {
            Swal.fire({ text: res.data.msg, icon: "warning" }).then(result => {
              if (result.isConfirmed) window.location.href = "/circular"
            })
          }
        })
        .catch(err => console.log(err))
    },
  })

  // ✅ FIX 1: classhandleChange updates Formik, not local state
  const classhandleChange = selectedOption => {
    if (user === "Admin") {
      const ids = selectedOption ? selectedOption.map(opt => opt.value) : []
      validation.setFieldValue("st_class", ids)
    } else {
      const values = selectedOption || []
      validation.setFieldValue("st_class", values)
    }
    validation.setFieldTouched("st_class", true, false)
  }

  // ✅ FIX 2: send_by handler also marks touched
  const handleChange = selectedOption => {
    validation.setFieldValue("send_by", selectedOption || [])
    validation.setFieldTouched("send_by", true, false)
  }

  return (
    <React.Fragment>
      <style>{`
        /* Make disabled / previous-month dates more visible in flatpickr */
        .flatpickr-day.flatpickr-disabled,
        .flatpickr-day.flatpickr-disabled:hover,
        .flatpickr-day.prevMonthDay,
        .flatpickr-day.nextMonthDay {
          color: #74788d !important;
          opacity: 0.85 !important;
        }
      `}</style>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Circular" breadcrumbItem="Create Circular" />
          <Row>
            <Col lg="12">
              <Card className="mb-5">
                {loading ? (
                  <Loading />
                ) : (
                  <CardBody>
                    <Form onSubmit={e => { e.preventDefault(); validation.handleSubmit() }}>
                      <Row>
                        <Col sm={12} lg={6}>

                          {/* Title */}
                          <div className="mb-2">
                            <Label htmlFor="title" className="my-control">Title</Label>
                            <Input
                              id="n_title"
                              name="title"
                              type="text"
                              className="form-control"
                              placeholder="Title"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.title}
                              invalid={validation.touched.title && !!validation.errors.title}
                            />
                            {validation.touched.title && validation.errors.title && (
                              <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                            )}
                          </div>

                          {/* Class / Class Group */}
                          <div className="mb-3">
                            {user === "Admin" ? (
                              <>
                                <Label className="control-label my-control">Class Group</Label>
                                <Select
                                  name="st_class"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class Group..."
                                  options={AllClassGroup}
                                  isMulti
                                  // ✅ FIX 3: value derived from Formik state, not local state
                                 value={AllClassGroup.filter(opt =>
  Array.isArray(validation.values.st_class) &&
  validation.values.st_class.includes(opt.value)
)}
                                  onChange={classhandleChange}
                                  onBlur={() => validation.setFieldTouched("st_class", true)}
                                />
                              </>
                            ) : (
                              <>
                                <Label className="control-label my-control">Class</Label>
                                <Select
                                  name="st_class"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class..."
                                  options={classListOption}
                                  isMulti
                                  // ✅ FIX 3: value derived from Formik state
                                  value={validation.values.st_class}
                                  onChange={classhandleChange}
                                  onBlur={() => validation.setFieldTouched("st_class", true)}
                                />
                              </>
                            )}
                            {validation.touched.st_class && validation.errors.st_class && (
                              <div style={{ color: "#f46a6a", fontSize: "11px", marginTop: "3px" }}>
                                This is required
                              </div>
                            )}
                          </div>

                          {/* Send By */}
                          <div className="mb-3">
                            <Label className="control-label my-control">To send</Label>
                            <Select
                              name="send_by"
                              classNamePrefix="select2-selection"
                              placeholder="Select..."
                              options={SendListOption}
                              isMulti
                              // ✅ FIX 3: value derived from Formik state
                              value={validation.values.send_by}
                              onChange={handleChange}
                              onBlur={() => validation.setFieldTouched("send_by", true)}
                            />
                            {validation.touched.send_by && validation.errors.send_by && (
                              <div style={{ color: "#f46a6a", fontSize: "11px", marginTop: "3px" }}>
                                This is required
                              </div>
                            )}
                          </div>

                          {/* Expiry Date */}
                          <div className="mb-3">
                            <Label className="form-label">Expiry Date</Label>
                            <Flatpickr
                              className="form-control"
                              placeholder="Select expiry date"
                              value={validation.values.circular_end_date}
                              options={{
                                dateFormat: "Y-m-d",
                                altInput: true,
                                altFormat: "d M Y",
                                minDate: "today",
                              }}
                              onChange={([date]) => {
                                if (date) {
                                  // Format using local date parts to avoid UTC
                                  // shifting the day back (e.g. selecting the 31st
                                  // becoming the 30th in IST).
                                  const yyyy = date.getFullYear()
                                  const mm = String(date.getMonth() + 1).padStart(2, "0")
                                  const dd = String(date.getDate()).padStart(2, "0")
                                  const formatted = `${yyyy}-${mm}-${dd}`
                                  validation.setFieldValue("circular_end_date", formatted)
                                }
                              }}
                            />
                          </div>

                        </Col>
                        <Col sm={12} lg={6}>

                          {/* Description */}
                          <div className="mb-3">
                            <Label htmlFor="Description">Description</Label>
                            <Input
                              id="n_description"
                              name="description"
                              rows="5"
                              type="textarea"
                              className="form-control"
                              placeholder="Write here your Description"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description}
                              invalid={validation.touched.description && !!validation.errors.description}
                            />
                            {validation.touched.description && validation.errors.description && (
                              <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                            )}
                          </div>

                          {/* File Upload */}
                          <div className="mt-0">
                            <Label className="control-label" htmlFor="input">
                              Upload Image or PDF
                            </Label>
                            <div className="input-group">
                              <Input
                                name="notice_file"
                                type="file"
                                className="form-control"
                                id="input"
                                onChange={e => {
                                  validation.setFieldValue("notice_file", e.target.files[0])
                                }}
                                invalid={validation.touched.notice_file && !!validation.errors.notice_file}
                              />
                            </div>
                            {validation.touched.notice_file && validation.errors.notice_file && (
                              <div style={{ color: "red", fontSize: "11px", marginTop: "3px" }}>
                                {validation.errors.notice_file}
                              </div>
                            )}
                          </div>

                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={12} className="d-flex align-items-end justify-content-end gap-2">
                          <Link to="/circular" className="btn btn-secondary waves-effect">
                            Back
                          </Link>
                          <Button color="primary" type="submit"
                            className="btn btn-primary waves-effect waves-light">
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateCircular